/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box, Button, MenuItem, Paper, Select, Tab, Tabs, Typography } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS, DRAWER_WIDTH_OPEN } from 'styles/theme';
import classNames from 'classnames';

import { GlobalDestinationServices } from './DestServices/globalDestinationServices.component';
import AssignmentLanding from './assignmentLanding.component';
// import countries from 'modules/common/countries.json';
import queryString from 'query-string';
import VisaTab from './visaTab.component';
import ServiceTriggeredComment from '../commentsAndNotes/serviceTriggeredComment.component';
import SlidingCommentsAndNotes from '../commentsAndNotes/commentsAndNotesSlidingPanel.component';
import { GLOBAL_STATUSES } from 'modules/enumerations/enumerationIds';
import { GET_GLOBAL_INFO_FAILURE, UPDATE_GLOBAL_ASSIGNMENT_FAILURE } from 'modules/authorizations/store/types/globalTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { updateGlobalAssignment, getGlobalInfo } from 'modules/authorizations/store/actions/global.actions';
import { CreateVendorRelationshipList } from 'modules/authorizations/utils';
import StatusMenu from 'modules/common/statusMenu.component';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';
import { GET_SERVICE_STATUS_DATES_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  drawerOpen: {
    width: `calc(100% - ${DRAWER_WIDTH_OPEN})`
  },
  headerFixed: {
    zIndex: 4
  },
  tabFixed: {
    paddingTop: '100px',
    zIndex: 3
  },
  estimateHeaderFixed: {
    paddingTop: '150px',
    zIndex: 2
  }
});

const validTabs = ['ASSIGNMENT', 'VISA', 'DESTINATION'];

const isValidQueryStringTab = tab => validTabs.includes(tab);

const getDefaultTab = location => {
  const tabFromQuery = queryString.parse(location.search)?.tab ?? 'ASSIGNMENT';
  return isValidQueryStringTab(tabFromQuery) ? tabFromQuery : 'ASSIGNMENT';
};

export const GLOBAL_STATUS_RANK = {
  [GLOBAL_STATUSES.INITIATED.toLowerCase()]: 2,
  [GLOBAL_STATUSES.ON_ASSIGNMENT.toLowerCase()]: 3,
  [GLOBAL_STATUSES.EXTENDED.toLowerCase()]: 4,
  [GLOBAL_STATUSES.ASSIGNMENT_ENDED.toLowerCase()]: 5,
  [GLOBAL_STATUSES.REPATRIATED.toLowerCase()]: 6,
  [GLOBAL_STATUSES.COMPLETED.toLowerCase()]: 7,
  [GLOBAL_STATUSES.ON_HOLD.toLowerCase()]: 8,
  [GLOBAL_STATUSES.CANCELED.toLowerCase()]: 9,
  [GLOBAL_STATUSES.NONE.toLowerCase()]: 10
};

const getRank = statusId => {
  if (!statusId) return Number.MAX_SAFE_INTEGER;
  return GLOBAL_STATUS_RANK[String(statusId).toLowerCase()] ?? Number.MAX_SAFE_INTEGER;
};

const GlobalService = props => {
  const {
    details,
    id,
    location,
    shouldShowSideDrawer,
    isReadOnly,
    enumerations,
    moveTypesEnum,
    globalServiceStatusTypesEnums,
    emailTemplates,
    clientInfo,
    vendors
  } = props;
  const [statuses, setStatuses] = useState(details?.serviceStatusDates ? details.serviceStatusDates.filter(s => s.serviceType === 'Global') : []);

    const getStatuses = async () => {
      if (details?.serviceStatusDates) {
        await props.getServiceStatusDates(id);
        setStatuses(details.serviceStatusDates.filter(s => s.serviceType === 'Global'));
      }
    }

    useEffect(() => {
      //setCurrentStatus(props.enumerations.buyerStatuses.find(bs => bs.id === buyer.buyerStatusId)?.title ?? 'Initiated');
      getStatuses();
    }, [details?.global?.globalInfo?.statusId]);

  let firstFamilyMemberId =
    details && Array.isArray(details.familyMembers) && details.familyMembers.length > 0 ? details.familyMembers[0].familyMemberId : 0;
  const [currentTab, setCurrentTab] = useState(getDefaultTab(location));
  const vendorsPreferredVendorSorted = CreateVendorRelationshipList(vendors, clientInfo?.clientDetails.clientVendorRelationships);
  const [familyMemberId, setFamilyMemberId] = useState(firstFamilyMemberId);
  const [refreshNecessary, setRefreshNecessary] = useState(false);

  const [showTriggeredComment, setShowTriggeredComment] = useState(false);
  const [showComment, setShowComment] = useState(false);

  const familyRelationshipTypes =
    enumerations && enumerations.familyRelationshipTypes && enumerations.familyRelationshipTypes.length > 0
      ? enumerations.familyRelationshipTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const globalStatuses =
    globalServiceStatusTypesEnums && globalServiceStatusTypesEnums.length > 0
      ? globalServiceStatusTypesEnums
          .filter(s => s.isActive === true)
          .map(s => ({
            id: s.id,
            title: s.title
          }))
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const moveTypes =
    moveTypesEnum && moveTypesEnum.length > 0
      ? moveTypesEnum.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentServiceTypes =
    enumerations && enumerations.authCommentService && enumerations.authCommentService.length > 0
      ? enumerations.authCommentService.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const authCommentRegardingTypes =
    enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
      ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  const calculateGlobalStatus = () => {
    if (!details || !details?.global?.globalInfo || details?.global?.globalInfo.statusId === '00000000-0000-0000-0000-000000000000')
      return 'Initiated';

    let selected = {
      id: details?.global?.globalInfo.statusId ? details?.global?.globalInfo.statusId : GLOBAL_STATUSES.INITIATED,
      rank: getRank(details?.global?.globalInfo.statusId)
    };

    return globalStatuses.find(s => isIdEqual(s.id, selected.id))?.title;
  };

  const [globalStatus, setGlobalStatus] = useState(details ? calculateGlobalStatus() : 'Initiated');
  const [pendingGlobalStatus, setPendingGlobalStatus] = useState(null);

  useEffect(() => {
    const currentStatusId = details?.global?.globalInfo?.statusId;
    if (pendingGlobalStatus && isIdEqual(currentStatusId, pendingGlobalStatus.id)) {
      setPendingGlobalStatus(null);
      return;
    }

    if (!pendingGlobalStatus) {
      setGlobalStatus(calculateGlobalStatus());
    }
  }, [details?.global?.globalInfo?.statusId, globalServiceStatusTypesEnums, pendingGlobalStatus]);

  useEffect(() => {
    async function fetchGlobal() {
      const getResp = await props.getGlobalInfo(id);
      if (getResp.type === GET_GLOBAL_INFO_FAILURE) {
        props.showToast('Failed to get global service info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
      setRefreshNecessary(false);
    }

    if (refreshNecessary) {
      fetchGlobal();
    }
  }, [id, refreshNecessary]);

  // useEffect(() => {

  //   async function fetchData() {
  //       await fetchAuthGlobalDetails(details, id, props);
  //     }

  //     fetchData();sss

  // }, []);

  const completeService = async () => {
    let newVals = { ...details?.global?.globalInfo };

    newVals.completedDate = new Date().toISOString();
    newVals.cancelledDate = null;
    newVals.onHoldDate = null;
    newVals.statusId = GLOBAL_STATUSES.COMPLETED;

    const resp = await props.updateGlobalAssignment(newVals);
    if (resp.type === UPDATE_GLOBAL_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update global service info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    } else {
      setGlobalStatus('Completed');
      setPendingGlobalStatus({ id: newVals.statusId, title: 'Completed' });
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      }
      else {
      setRefreshNecessary(true);
    }}
  };

  const setOnHold = async () => {
    let newVals = { ...details?.global?.globalInfo };

    newVals.completedDate = null;
    newVals.cancelledDate = null;
    newVals.onHoldDate = new Date().toISOString();
    newVals.statusId = GLOBAL_STATUSES.ON_HOLD;

    const resp = await props.updateGlobalAssignment(newVals);
    if (resp.type === UPDATE_GLOBAL_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update global service info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    } else {
      setGlobalStatus('On Hold');
      setPendingGlobalStatus({ id: newVals.statusId, title: 'On Hold' });
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      }
      else {
      setRefreshNecessary(true);
    }}
  };

  const cancelService = async () => {
    let newVals = { ...details?.global?.globalInfo };

    newVals.completedDate = null;
    newVals.cancelledDate = new Date().toISOString();
    newVals.onHoldDate = null;
    newVals.statusId = GLOBAL_STATUSES.CANCELED;

    const resp = await props.updateGlobalAssignment(newVals);
    if (resp.type === UPDATE_GLOBAL_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update global service info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    } else {
      setGlobalStatus('Canceled');
      setPendingGlobalStatus({ id: newVals.statusId, title: 'Canceled' });
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      }
      else {
      setRefreshNecessary(true);
    }}
  };

  const resetService = async () => {
    let newVals = { ...details?.global?.globalInfo };

    newVals.completedDate = null;
    newVals.cancelledDate = null;
    newVals.onHoldDate = null;
    newVals.statusId = GLOBAL_STATUSES.INITIATED;

    const resp = await props.updateGlobalAssignment(newVals);
    if (resp.type === UPDATE_GLOBAL_ASSIGNMENT_FAILURE) {
      props.showToast('Failed to update global service info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return false;
    } else {
      setGlobalStatus('Initiated');
      setPendingGlobalStatus({ id: newVals.statusId, title: 'Initiated' });
      const getStatusDatesResp = await props.getServiceStatusDates(id);
      if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
        return false;
      }
      else {
      setRefreshNecessary(true);
    }}
  };

  const changeTab = tab => {
    setCurrentTab(tab);
    const values = queryString.parse(location.search);
    values.tab = tab;
    props.history.replace(`${location.pathname}?${queryString.stringify(values)}`);
  };
    const [openStatusMenu, setOpenStatusMenu] = useState(false);

    const globalStatusOrder = [
      {
        title: 'Initiated',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Initiated')?.id : '',
        isActive: true,
        date: details?.global?.globalInfo?.addedOn ?? null
      },
      {
        title: 'On Assignment',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'On Assignment')?.id : '',
        isActive: true,
        date: details?.global?.globalInfo?.actualStart ?? null
      },
      {
        title: 'Extended',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Extended')?.id : '',
        isActive: true,
        date: details?.global?.globalExtensions?.length > 0 ? details?.global?.globalExtensions[0]?.extensionStartDate ?? null : null
      },
      {
        title: 'Assignment Ended',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Assignment Ended')?.id : '',
        isActive: true,
        date: details?.global?.globalInfo?.assignmentEndedDate ?? null
      },
      {
        title: 'Repatriated',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Repatriated')?.id : '',
        isActive: true,
        date: details?.global?.globalInfo?.repatriatedDate  ?? null
      },
      {
        title: 'Canceled',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'Canceled')?.id : '',
        isActive: false,
        date: details?.global?.globalInfo?.cancelledDate ?? null,
      },
      {
        title: 'On Hold',
        id: enumerations && enumerations.globalServiceStatusTypes && enumerations.globalServiceStatusTypes.length > 0          
        ? enumerations.globalServiceStatusTypes.find(s => s.title === 'On Hold')?.id : '',
        isActive: false,
        date: details?.global?.globalInfo?.onHoldDate ?? null,
      }
    ];

  return (
    <>
      <Box>
        {showComment && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 1200,
              pointerEvents: 'none'
            }}
          />
        )}
        <Paper
          square
          className={classNames({
            'position-fixed': !isReadOnly,
            [props.classes.headerFixed]: !isReadOnly,
            [props.classes.container]: true,
            [props.classes.drawerOpen]: shouldShowSideDrawer
          })}
          sx={isReadOnly ? { paddingTop: '5px', zIndex: 4, position: 'relative' } : {}}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
              <div></div>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
              <StatusMenu
                anchorEl={openStatusMenu}
                onClose={() => setOpenStatusMenu(false)}
                currentStatus={globalStatus}
                statusHeader="Global Status"
                statusList={globalStatusOrder ? globalStatusOrder : []}
                statusDates={statuses}
                classes={props.classes}
              />
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    {details?.authGlobal?.global?.type === 3 ? 'Destination' : 'Host'} Location
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {details && details.global && enumerations.countries && details.global.globalInfo.assignmentCountryId ? (
                      enumerations.countries.find(c => c.id === details.global.globalInfo.assignmentCountryId)?.title
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    Move Type
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {moveTypes && moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId) ? (
                      moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId).title
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
                    Policy
                  </Typography>
                </Box>
                <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
                    {details.authorizationDetails.billingPolicyId}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '20px' }}>
              {!isReadOnly && (
                <Box>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#f01dc9ff',
                      '&:hover': { backgroundColor: '#ba007fff' }
                    }}
                    onClick={resetService}
                  >
                    Reset (Testing)
                  </Button>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{
                      maxHeight: '40px',
                      marginLeft: '12px',
                      marginTop: '8px',
                      backgroundColor: '#868686',
                      '&:hover': { backgroundColor: '#474747' }
                    }}
                    onClick={cancelService}
                  >
                    {details && details?.global?.globalInfo && details?.global?.globalInfo?.cancelledDate
                      ? 'Uncancel Serivice'
                      : 'Cancel Service'}
                  </Button>
                </Box>
              )}
              {!isReadOnly && (
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={setOnHold}
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#f0b11d',
                    '&:hover': { backgroundColor: '#ba8a00' }
                  }}
                >
                  {' '}
                  Set On Hold{' '}
                </Button>
              )}
              {!isReadOnly && (
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                  onClick={completeService}
                >
                  {' '}
                  Complete Service{' '}
                </Button>
              )}
              <Button
                onClick={() => setShowComment(true)}
                variant="contained"
                sx={{
                  maxHeight: '40px',
                  marginLeft: '12px',
                  marginTop: '8px',
                  backgroundColor: '#41B7C0',
                  color: 'white',
                  '&:hover': { backgroundColor: '#3d959c' }
                }}
              >
                Comments
              </Button>
            </Box>
          </Box>
        </Paper>
        <Paper
          square
          className={classNames({
            'position-fixed': !isReadOnly,
            [props.classes.tabFixed]: !isReadOnly,
            [props.classes.container]: true,
            [props.classes.drawerOpen]: shouldShowSideDrawer
          })}
          sx={isReadOnly ? { paddingTop: '5px', zIndex: 3, position: 'relative' } : {}}
        >
          <Tabs variant="fullWidth" value={currentTab} onChange={(event, tab) => changeTab(tab)} sx={{}}>
            <Tab value={'ASSIGNMENT'} label="Assignment Details" />
            <Tab value={'VISA'} label="Visa & Vaccine" />
            <Tab value={'DESTINATION'} label="Destination Services" />
            {/* <Tab value={'PROPERTY'} label="Property Management" /> */}
            {/* <Tab value={'FINANCIAL'} label="Financial" /> */}
          </Tabs>
        </Paper>

        {/* Property tab selector removed */}
        {/* {currentTab === 'PROPERTY' && (
          <Paper
            square
            className={classNames({
              'position-fixed': !isReadOnly,
              [props.classes.estimateHeaderFixed]: !isReadOnly,
              [props.classes.container]: true,
              [props.classes.drawerOpen]: shouldShowSideDrawer
            })}
            sx={isReadOnly ? { paddingTop: '5px', zIndex: 2, position: 'relative' } : {}}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: hostServiceSelected ? '#5D9878' : '#ffffff',
                    '&:hover': { backgroundColor: hostServiceSelected ? '#416A54' : '#faf8f2' },
                    color: hostServiceSelected ? 'ffffff' : '#080600'
                  }}
                  onClick={() => setHostServiceSelected(true)}
                >
                  {' '}
                  Host Service{' '}
                </Button>
                <Button
                  color="secondary"
                  type="submit"
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: !hostServiceSelected ? '#5D9878' : '#ffffff',
                    '&:hover': { backgroundColor: !hostServiceSelected ? '#416A54' : '#faf8f2' },
                    color: !hostServiceSelected ? 'ffffff' : '#080600'
                  }}
                  onClick={() => setHostServiceSelected(false)}
                >
                  {' '}
                  Home Service{' '}
                </Button>
              </Box>
              <Box />
            </Box>
          </Paper>
        )} */}

        {currentTab === 'VISA' && (
          <Paper
            square
            className={classNames({
              'position-fixed': !isReadOnly,
              [props.classes.estimateHeaderFixed]: !isReadOnly,
              [props.classes.container]: true,
              [props.classes.drawerOpen]: shouldShowSideDrawer
            })}
            sx={isReadOnly ? { paddingTop: '5px', zIndex: 2, position: 'relative' } : {}}
          >
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row', paddingLeft: '20px' }}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 500, fontSize: '1rem', textAlign: 'center', paddingTop: '12px', paddingRight: '16px' }}
                >
                  Family Member
                </Typography>
                <Select
                  labelId={'familyMemberId'}
                  key={'familyMemberId'}
                  label={''}
                  name={'familyMemberId'}
                  value={familyMemberId}
                  sx={{ maxWidth: '360px', minWidth: '180px' }}
                  onChange={e => setFamilyMemberId(e.target.value)}
                >
                  {details &&
                    details.familyMembers &&
                    details.familyMembers.map(opt => (
                      <MenuItem key={opt.familyMemberId} value={opt.familyMemberId} sx={{ margin: 'dense' }}>
                        {`${opt.firstName} ${opt.lastName} (${familyRelationshipTypes.find(s => s.id === opt.familyRelationshipTypeId)
                          ?.title || ''})`}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            </Box>
          </Paper>
        )}

        <Box
          sx={{ padding: '20px', paddingTop: isReadOnly ? '20px' : currentTab === 'VISA' ? '245px' : '165px' }}
        >
          {currentTab === 'ASSIGNMENT' && (
            <AssignmentLanding
              details={details}
              id={id}
              isReadOnly={isReadOnly}
              location={props.location}
              enumerations={enumerations}
              globalStatus={globalStatus}
              emailTemplates={emailTemplates}
              allVendorOptions={vendorsPreferredVendorSorted}
              history={props.history}
              authCommentServiceTypes={authCommentServiceTypes}
              authCommentRegardingTypes={authCommentRegardingTypes}
              setStatusDates={setStatuses}
            />
          )}
          {currentTab === 'VISA' && (
            <VisaTab details={details} id={id} familyMemberId={familyMemberId} isReadOnly={isReadOnly} enumerations={enumerations} />
          )}
          {currentTab === 'DESTINATION' && (
            <GlobalDestinationServices
              details={details}
              id={id}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              vendors={vendorsPreferredVendorSorted}
              vendorContacts={props.vendorContacts}
              allVendors={vendors}
            />
          )}
          {/* Property Management and Financial tabs are hidden */}
          {/* {currentTab === 'PROPERTY' && (
            <PropertyManagement
              details={details}
              id={id}
              hostServiceSelected={hostServiceSelected}
              isReadOnly={isReadOnly}
              enumerations={enumerations}
              vendors={vendorsPreferredVendorSorted}
              vendorContacts={props.vendorContacts}
              brokerAgents={props.brokerAgents}
              allVendors={vendors}
            />
          )}
          {currentTab === 'FINANCIAL' && (
            <Box sx={{ width: '100%', minHeight: '300px' }}>
              <Grid container spacing={2} sx={{ padding: '20px' }}>
                <Grid item xs={12}>
                  <h1> FINANCIAL</h1>
                </Grid>
              </Grid>
            </Box>
          )} */}
        </Box>
      </Box>
      {showTriggeredComment && (
        <ServiceTriggeredComment
          authorizationId={id}
          serviceOptionId={'7d4d3d04-66b8-4d44-9131-5c7b2cf8b1f6'}
          displayText={'Global - Service Completed Comment'}
          setShowTriggeredComment={setShowTriggeredComment}
        />
      )}
      {showComment && <SlidingCommentsAndNotes authorizationId={id} serviceOptionId={'7d4d3d04-66b8-4d44-9131-5c7b2cf8b1f6'} setShowComment={setShowComment} isOpen={true} />}
    </>
  );
};

GlobalService.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { moveTypes, globalServiceStatusTypes } = state.enumerations.allEnums;

  return {
    shouldShowSideDrawer: state.layout.shouldShowSideDrawer,
    moveTypesEnum: moveTypes,
    globalServiceStatusTypesEnums: globalServiceStatusTypes
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    showToast,
    updateGlobalAssignment,
    getGlobalInfo,
    getServiceStatusDates
  })
)(GlobalService);
